<template>
    <div class="group-bg-main st-banner">
        <div class="st sec-newhome-main bg-banner-kv pd pb-0">
            <div class="ele ele-main-kv-cloud">
                <img class="fw" src="@/assets/img/home/cloud-hero-banner.png" alt="" />
            </div>
            <div class="container container-1360">
                <div class="position-relative pd-b">
                    <div class="ele ele-banner-kv-ink-m d-block d-md-none">
                        <img src="@/assets/list-detail/newhome/Ink_1.png" alt="" />
                    </div>
                    <div class="banner-cont">
                        <div class="ele ele-banner-kv-ink d-none d-md-block">
                            <img src="@/assets/list-detail/newhome/Ink_1.png" alt="" />
                        </div>
                        <div class="newhome-logo text-center d-none d-md-block">
                            <img class="logo-kv" src="@/assets/img/skin/logo.png" alt="" />
                            <h4 class="text-light txt-w-md banner-t-2">
                                <b>25 แหล่งท่องเที่ยว UNSEEN<br />มุมใหม่ของเมืองไทย</b>
                            </h4>
                            <!-- <router-link class="btn btn-ctr-primary rounded-pill mt-2"
                                to="/attractions">ดูแหล่งท่องเที่ยวทั้งหมด</router-link> -->
                        </div>
                        <div class="newhome-video-banner">
                            <div class="box-connt-baner-new">
                                <div class="box-video">
                                    <div class="ganeral-video">
                                        <div class="video-container inactive-state click-to-play-video auto-init"
                                            :class="[hidePreview ? 'hidePreview' : '']" ref="player">
                                            <div class="video-put" data-video="oX8Yq0Iqjcg" data-code="1"
                                                section_type="video">
                                                <div id="player_ganeral_1_video" class="player_ganeral" ref="iframe"></div>
                                            </div>
                                            <div class="video-space d-flex h-100">
                                                <img class="float-left w-100" style="object-fit: cover"
                                                    src="@/assets/img/home/banner-video.jpg" />
                                            </div>
                                            <div class="videoplay-icon">
                                                <img class="" src="@/assets/img/skin/btn-play.svg" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="newhome-logo-m d-block d-md-none">
                            <img class="logo-kv" src="@/assets/img/skin/logo.png" alt="" />
                        </div>
                        <div class="newhome-sub-m text-center d-block d-md-none">
                            <h2 class="text-light txt-w-md banner-t-2">
                                <b>25 แหล่งท่องเที่ยว UNSEEN<br />มุมใหม่ของเมืองไทย</b>
                            </h2>
                            <!-- <router-link class="btn btn-ctr-primary rounded-pill mt-2"
                                to="/attractions">ดูแหล่งท่องเที่ยวทั้งหมด</router-link> -->
                        </div>
                    </div>
                    <div class="st sec-newhome-location text-center bg-gd">
                        <h2 class="text-light txt-w-lg">
                            25 แหล่งท่องเที่ยว
                            <span style="display: inline-block" class="text-uppercase">Unseen New Chapters</span>
                        </h2>
                    </div>
                </div>
            </div>
        </div>
        <div class="st sec sec-location-tab">
            <div class="container container-1360">
                <div class="position-relative">
                    <div class="sec-tab sec-newhome-tab nx-bg-pd-primary">
                        <ul ref="tabList">
                            <li class="tab-list" @click="activateTab('all')" :class="{ active: activeTab === 'all' }">
                                <a href="javascript:void(0)" class="tab-a"><span>ทั้งหมด</span></a>
                            </li>
                            <li class="tab-list" @click="activateTab('north')" :class="{ active: activeTab === 'north' }">
                                <a href="javascript:void(0)" class="tab-a"><span>ภาคเหนือ</span></a>
                            </li>
                            <li class="tab-list" @click="activateTab('central')"
                                :class="{ active: activeTab === 'central' }">
                                <a href="javascript:void(0)" class="tab-a"><span>ภาคกลาง</span></a>
                            </li>
                            <li class="tab-list" @click="activateTab('northeast')"
                                :class="{ active: activeTab === 'northeast' }">
                                <a href="javascript:void(0)" class="tab-a"><span>ภาคอีสาน</span></a>
                            </li>
                            <li class="tab-list" @click="activateTab('eastern')"
                                :class="{ active: activeTab === 'eastern' }">
                                <a href="javascript:void(0)" class="tab-a"><span>ภาคตะวันออก</span></a>
                            </li>
                            <li class="tab-list" @click="activateTab('south')" :class="{ active: activeTab === 'south' }">
                                <a href="javascript:void(0)" class="tab-a"><span>ภาคใต้</span></a>
                            </li>
                        </ul>
                    </div>
                    <div class="sec-locationlist pd pb-0">
                        <div class="newhome-tab-content">

                                    <div class="location-list" :class="[activeTab === 'all' ? 'active' : '']"
                                        ref="tabContent">
                                        <div
                                            class="row g-custom g-3 row-cols-2 row-cols-md-3 row-cols-lg-4 row-cols-xl-4 row-cols-xxl-5 g-4 g-xl-5">
                                                <div class="col" >
                                                    <a href="/phetchabun">
                                                        <div class="card card-vote">
                                                            <div class="card-img">
                                                                <img src="@/assets/img/_77-attractions/north/phetchabun/phetchabun-thumb.jpg"
                                                                    alt="" class="fw" />
                                                            </div>
                                                            <div class="card-body px-0 pb-0">
                                                                <div class="card-cont">
                                                                    <h6 ref="cardContentLocation"><b>มหัศจรรย์น้ำตกหมอกเมืองไทย</b></h6>
                                                                    <p class="gray-dark">
                                                                        <small>จ.เพชรบูรณ์ ภาคเหนือ</small>
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div class="card-foot">
                                                                <span class="btn-txt-grey btn-icon d-inline-block">
                                                                    <span>
                                                                        <span class="info-btn">ดูรายละเอียด</span>
                                                                        <img class="svg"
                                                                            src="@/assets/list-detail/icon-arrow-right-grey.svg"
                                                                            alt="" />
                                                                    </span>
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </a>
                                                </div>
                                                <div class="col" >
                                                    <a href="/nakhon-sawan">
                                                        <div class="card card-vote">
                                                            <div class="card-img">
                                                                <img src="@/assets/img/_77-attractions/north/nakhon-sawan/nakhon-sawan-thumb.jpg"
                                                                    alt="" class="fw" />
                                                            </div>
                                                            <div class="card-body px-0 pb-0">
                                                                <div class="card-cont">
                                                                    <h6 ref="cardContentLocation"><b>ความศิวิไลซ์…แห่งปากน้ำโพ</b></h6>
                                                                    <p class="gray-dark">
                                                                        <small>จ.นครสวรรค์ ภาคเหนือ</small>
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div class="card-foot">
                                                                <span class="btn-txt-grey btn-icon d-inline-block">
                                                                    <span>
                                                                        <span class="info-btn">ดูรายละเอียด</span>
                                                                        <img class="svg"
                                                                            src="@/assets/list-detail/icon-arrow-right-grey.svg"
                                                                            alt="" />
                                                                    </span>
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </a>
                                                </div>
                                                <div class="col" >
                                                    <a href="/lampang">
                                                        <div class="card card-vote">
                                                            <div class="card-img">
                                                                <img src="@/assets/img/_77-attractions/north/lampang/lampang-thumb.jpg"
                                                                    alt="" class="fw" />
                                                            </div>
                                                            <div class="card-body px-0 pb-0">
                                                                <div class="card-cont">
                                                                    <h6 ref="cardContentLocation"><b>นมัสการพระใหญ่…ลมหายใจแห่งไดบุตสึ</b></h6>
                                                                    <p class="gray-dark">
                                                                        <small>จ.ลำปาง ภาคเหนือ</small>
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div class="card-foot">
                                                                <span class="btn-txt-grey btn-icon d-inline-block">
                                                                    <span>
                                                                        <span class="info-btn">ดูรายละเอียด</span>
                                                                        <img class="svg"
                                                                            src="@/assets/list-detail/icon-arrow-right-grey.svg"
                                                                            alt="" />
                                                                    </span>
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </a>
                                                </div>
                                                <div class="col" >
                                                    <a href="/lamphun">
                                                        <div class="card card-vote">
                                                            <div class="card-img">
                                                                <img src="@/assets/img/_77-attractions/north/lamphun/lamphun-thumb.jpg"
                                                                    alt="" class="fw" />
                                                            </div>
                                                            <div class="card-body px-0 pb-0">
                                                                <div class="card-cont">
                                                                    <h6 ref="cardContentLocation"><b>ตระการตาแห่งสีสัน…มหัศจรรย์ทะเลโคม</b></h6>
                                                                    <p class="gray-dark">
                                                                        <small>จ.ลำพูน ภาคเหนือ</small>
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div class="card-foot">
                                                                <span class="btn-txt-grey btn-icon d-inline-block">
                                                                    <span>
                                                                        <span class="info-btn">ดูรายละเอียด</span>
                                                                        <img class="svg"
                                                                            src="@/assets/list-detail/icon-arrow-right-grey.svg"
                                                                            alt="" />
                                                                    </span>
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </a>
                                                </div>
                                                <div class="col" >
                                                    <a href="/nan">
                                                        <div class="card card-vote">
                                                            <div class="card-img">
                                                                <img src="@/assets/img/_77-attractions/north/nan/nan-thumb.jpg"
                                                                    alt="" class="fw" />
                                                            </div>
                                                            <div class="card-body px-0 pb-0">
                                                                <div class="card-cont">
                                                                    <h6 ref="cardContentLocation"><b>ธรรม...ในถ้ำ วัดถ้ำเชตวัน</b></h6>
                                                                    <p class="gray-dark">
                                                                        <small>จ.น่าน ภาคเหนือ</small>
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div class="card-foot">
                                                                <span
                                                                    class="nx-bg-pd-primary judge-tag text-light">
                                                                    <img class="svg judge-icon"
                                                                        src="@/assets/list-detail/icon-Star.svg" alt="" />
                                                                    <span
                                                                        class="d-none d-xl-block judge-txt">คัดเลือกโดยผู้ทรงคุณวุฒิ</span>
                                                                    <span
                                                                        class="d-block d-xl-none judge-txt">ผู้ทรงคุณวุฒิ</span>
                                                                </span>
                                                                <span class="btn-txt-grey btn-icon d-inline-block">
                                                                    <span>
                                                                        <span class="info-btn">ดูรายละเอียด</span>
                                                                        <img class="svg"
                                                                            src="@/assets/list-detail/icon-arrow-right-grey.svg"
                                                                            alt="" />
                                                                    </span>
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </a>
                                                </div>
                                                <div class="col" >
                                                    <a href="/saraburi">
                                                        <div class="card card-vote">
                                                            <div class="card-img">
                                                                <img src="@/assets/img/_77-attractions/central/saraburi/saraburi-thumb.jpg"
                                                                    alt="" class="fw" />
                                                            </div>
                                                            <div class="card-body px-0 pb-0">
                                                                <div class="card-cont">
                                                                    <h6 ref="cardContentLocation"><b>ธรรมะแกลลอรี่…คอมมูนิตี้กลางหุบเขา</b></h6>
                                                                    <p class="gray-dark">
                                                                        <small>จ.สระบุรี ภาคกลาง</small>
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div class="card-foot">
                                                                
                                                                <span class="btn-txt-grey btn-icon d-inline-block">
                                                                    <span>
                                                                        <span class="info-btn">ดูรายละเอียด</span>
                                                                        <img class="svg"
                                                                            src="@/assets/list-detail/icon-arrow-right-grey.svg"
                                                                            alt="" />
                                                                    </span>
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </a>
                                                </div>
                                                <div class="col" >
                                                    <a href="/petchaburi">
                                                        <div class="card card-vote">
                                                            <div class="card-img">
                                                                <img src="@/assets/img/_77-attractions/central/phetchaburi/phetchaburi-thumb.jpg"
                                                                    alt="" class="fw" />
                                                            </div>
                                                            <div class="card-body px-0 pb-0">
                                                                <div class="card-cont">
                                                                    <h6 ref="cardContentLocation"><b>ผจญภัยในถ้ำโบ้…สำรวจถ้ำแห่งเขาอีบิด</b></h6>
                                                                    <p class="gray-dark">
                                                                        <small>จ.เพชรบุรี ภาคกลาง</small>
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div class="card-foot">
                                                                <span class="btn-txt-grey btn-icon d-inline-block">
                                                                    <span>
                                                                        <span class="info-btn">ดูรายละเอียด</span>
                                                                        <img class="svg"
                                                                            src="@/assets/list-detail/icon-arrow-right-grey.svg"
                                                                            alt="" />
                                                                    </span>
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </a>
                                                </div>
                                                <div class="col" >
                                                    <a href="/kanchanaburi">
                                                        <div class="card card-vote">
                                                            <div class="card-img">
                                                                <img src="@/assets/img/_77-attractions/central/kanchanaburi/kanchanaburi-thumb.jpg"
                                                                    alt="" class="fw" />
                                                            </div>
                                                            <div class="card-body px-0 pb-0">
                                                                <div class="card-cont">
                                                                    <h6 ref="cardContentLocation"><b>ฝ่าอุโมงค์สามมิติ…พิชิตป่าล้อมเหมือง</b></h6>
                                                                    <p class="gray-dark">
                                                                        <small>จ.กาญจนบุรี ภาคกลาง</small>
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div class="card-foot">
                                                                <span class="btn-txt-grey btn-icon d-inline-block">
                                                                    <span>
                                                                        <span class="info-btn">ดูรายละเอียด</span>
                                                                        <img class="svg"
                                                                            src="@/assets/list-detail/icon-arrow-right-grey.svg"
                                                                            alt="" />
                                                                    </span>
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </a>
                                                </div>
                                                <div class="col" >
                                                    <a href="/ratchaburi">
                                                        <div class="card card-vote">
                                                            <div class="card-img">
                                                                <img src="@/assets/img/_77-attractions/central/ratchaburi/ratchaburi-thumb.jpg"
                                                                    alt="" class="fw" />
                                                            </div>
                                                            <div class="card-body px-0 pb-0">
                                                                <div class="card-cont">
                                                                    <h6 ref="cardContentLocation"><b>อันซีนภูผาแรด…มุมลับสุดอาร์ตแห่งราชบุรี</b></h6>
                                                                    <p class="gray-dark">
                                                                        <small>จ.ราชบุรี ภาคกลาง</small>
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div class="card-foot">
                                                                <span class="btn-txt-grey btn-icon d-inline-block">
                                                                    <span>
                                                                        <span class="info-btn">ดูรายละเอียด</span>
                                                                        <img class="svg"
                                                                            src="@/assets/list-detail/icon-arrow-right-grey.svg"
                                                                            alt="" />
                                                                    </span>
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </a>
                                                </div>
                                                <div class="col" >
                                                    <a href="/prachuap-khiri-khan">
                                                        <div class="card card-vote">
                                                            <div class="card-img">
                                                                <img src="@/assets/img/_77-attractions/central/prachuap-khiri-khan/prachuap-khiri-khan-thumb.jpg"
                                                                    alt="" class="fw" />
                                                            </div>
                                                            <div class="card-body px-0 pb-0">
                                                                <div class="card-cont">
                                                                    <h6 ref="cardContentLocation"><b>มหาเจดีย์แห่งรัชสมัย…ความภาคภูมิใจแห่งบางสะพาน</b></h6>
                                                                    <p class="gray-dark">
                                                                        <small>จ.ประจวบคีรีขันธ์ ภาคกลาง</small>
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div class="card-foot">
                                                                <span
                                                                    class="nx-bg-pd-primary judge-tag text-light">
                                                                    <img class="svg judge-icon"
                                                                        src="@/assets/list-detail/icon-Star.svg" alt="" />
                                                                    <span
                                                                        class="d-none d-xl-block judge-txt">คัดเลือกโดยผู้ทรงคุณวุฒิ</span>
                                                                    <span
                                                                        class="d-block d-xl-none judge-txt">ผู้ทรงคุณวุฒิ</span>
                                                                </span>
                                                                <span class="btn-txt-grey btn-icon d-inline-block">
                                                                    <span>
                                                                        <span class="info-btn">ดูรายละเอียด</span>
                                                                        <img class="svg"
                                                                            src="@/assets/list-detail/icon-arrow-right-grey.svg"
                                                                            alt="" />
                                                                    </span>
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </a>
                                                </div>
                                                
                                                <div class="col" >
                                                    <a href="/chaiyaphum">
                                                        <div class="card card-vote">
                                                            <div class="card-img">
                                                                <img src="@/assets/img/_77-attractions/northeast/chaiyaphum/chaiyaphum-thumb.jpg"
                                                                    alt="" class="fw" />
                                                            </div>
                                                            <div class="card-body px-0 pb-0">
                                                                <div class="card-cont">
                                                                    <h6 ref="cardContentLocation"><b>ท่องอาณาจักรสวนหินล้านปี มอหินขาว</b></h6>
                                                                    <p class="gray-dark">
                                                                        <small>จ.ชัยภูมิ ภาคอีสาน</small>
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div class="card-foot">
                                                                <span class="btn-txt-grey btn-icon d-inline-block">
                                                                    <span>
                                                                        <span class="info-btn">ดูรายละเอียด</span>
                                                                        <img class="svg"
                                                                            src="@/assets/list-detail/icon-arrow-right-grey.svg"
                                                                            alt="" />
                                                                    </span>
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </a>
                                                </div>
                                                <div class="col" >
                                                    <a href="/loei">
                                                        <div class="card card-vote">
                                                            <div class="card-img">
                                                                <img src="@/assets/img/_77-attractions/northeast/loei/loei-thumb.jpg"
                                                                    alt="" class="fw" />
                                                            </div>
                                                            <div class="card-body px-0 pb-0">
                                                                <div class="card-cont">
                                                                    <h6 ref="cardContentLocation"><b>พิสูจน์ความฟิต…พิชิตทะเลหมอก ณ วนอุทยานภูบ่อบิด</b></h6>
                                                                    <p class="gray-dark">
                                                                        <small>จ.เลย ภาคอีสาน</small>
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div class="card-foot">
                                                                <span class="btn-txt-grey btn-icon d-inline-block">
                                                                    <span>
                                                                        <span class="info-btn">ดูรายละเอียด</span>
                                                                        <img class="svg"
                                                                            src="@/assets/list-detail/icon-arrow-right-grey.svg"
                                                                            alt="" />
                                                                    </span>
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </a>
                                                </div>
                                                <div class="col" >
                                                    <a href="/sisaket">
                                                        <div class="card card-vote">
                                                            <div class="card-img">
                                                                <img src="@/assets/img/_77-attractions/northeast/sisaket/sisaket-thumb.jpg"
                                                                    alt="" class="fw" />
                                                            </div>
                                                            <div class="card-body px-0 pb-0">
                                                                <div class="card-cont">
                                                                    <h6 ref="cardContentLocation"><b>ชมวิวบนยอดผา ณ ผืนป่าบ้านพญากูปรี</b></h6>
                                                                    <p class="gray-dark">
                                                                        <small>จ.ศรีสะเกษ ภาคอีสาน</small>
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div class="card-foot">
                                                              
                                                                <span class="btn-txt-grey btn-icon d-inline-block">
                                                                    <span>
                                                                        <span class="info-btn">ดูรายละเอียด</span>
                                                                        <img class="svg"
                                                                            src="@/assets/list-detail/icon-arrow-right-grey.svg"
                                                                            alt="" />
                                                                    </span>
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </a>
                                                </div>
                                                <div class="col" >
                                                    <a href="/nakhon-ratchasima">
                                                        <div class="card card-vote">
                                                            <div class="card-img">
                                                                <img src="@/assets/img/_77-attractions/northeast/nakhon-ratchasima/nakhon-ratchasima-thumb.jpg"
                                                                    alt="" class="fw" />
                                                            </div>
                                                            <div class="card-body px-0 pb-0">
                                                                <div class="card-cont">
                                                                    <h6 ref="cardContentLocation"><b>สัมผัสเสน่ห์เหนือกาลเวลา ณ ชุมชนบ้านปรางค์นคร อาณาจักรย่าโม</b></h6>
                                                                    <p class="gray-dark">
                                                                        <small>จ.นครราชสีมา ภาคอีสาน</small>
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div class="card-foot">
                                                                <span class="btn-txt-grey btn-icon d-inline-block">
                                                                    <span>
                                                                        <span class="info-btn">ดูรายละเอียด</span>
                                                                        <img class="svg"
                                                                            src="@/assets/list-detail/icon-arrow-right-grey.svg"
                                                                            alt="" />
                                                                    </span>
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </a>
                                                </div>
                                                
                                                <div class="col" >
                                                    <a href="/maha-sarakham">
                                                        <div class="card card-vote">
                                                            <div class="card-img">
                                                                <img src="@/assets/img/_77-attractions/northeast/maha-sarakham/maha-sarakham-thumb.jpg"
                                                                    alt="" class="fw" />
                                                            </div>
                                                            <div class="card-body px-0 pb-0">
                                                                <div class="card-cont">
                                                                    <h6 ref="cardContentLocation"><b>มหาศรัทธา…มหาอุโบสถตะเคียนทอง</b></h6>
                                                                    <p class="gray-dark">
                                                                        <small>จ.มหาสารคาม ภาคอีสาน</small>
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div class="card-foot">
                                                                <span
                                                                    class="nx-bg-pd-primary judge-tag text-light">
                                                                    <img class="svg judge-icon"
                                                                        src="@/assets/list-detail/icon-Star.svg" alt="" />
                                                                    <span
                                                                        class="d-none d-xl-block judge-txt">คัดเลือกโดยผู้ทรงคุณวุฒิ</span>
                                                                    <span
                                                                        class="d-block d-xl-none judge-txt">ผู้ทรงคุณวุฒิ</span>
                                                                </span>
                                                                <span class="btn-txt-grey btn-icon d-inline-block">
                                                                    <span>
                                                                        <span class="info-btn">ดูรายละเอียด</span>
                                                                        <img class="svg"
                                                                            src="@/assets/list-detail/icon-arrow-right-grey.svg"
                                                                            alt="" />
                                                                    </span>
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </a>
                                                </div>
                                                
                                                <div class="col" >
                                                    <a href="/chonburi">
                                                        <div class="card card-vote">
                                                            <div class="card-img">
                                                                <img src="@/assets/img/_77-attractions/eastern/chonburi/chonburi-thumb.jpg"
                                                                    alt="" class="fw" />
                                                            </div>
                                                            <div class="card-body px-0 pb-0">
                                                                <div class="card-cont">
                                                                    <h6 ref="cardContentLocation"><b>อันซีนเกาะแห่งรัก(ษ์)...ที่สีชัง</b></h6>
                                                                    <p class="gray-dark">
                                                                        <small>จ.ชลบุรี ภาคตะวันออก</small>
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div class="card-foot">
                                                                <span class="btn-txt-grey btn-icon d-inline-block">
                                                                    <span>
                                                                        <span class="info-btn">ดูรายละเอียด</span>
                                                                        <img class="svg"
                                                                            src="@/assets/list-detail/icon-arrow-right-grey.svg"
                                                                            alt="" />
                                                                    </span>
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </a>
                                                </div>
                                                <div class="col" >
                                                    <a href="/nakhonnayok">
                                                        <div class="card card-vote">
                                                            <div class="card-img">
                                                                <img src="@/assets/img/_77-attractions/eastern/nakhonnayok/nakhonnayok-thumb.jpg"
                                                                    alt="" class="fw" />
                                                            </div>
                                                            <div class="card-body px-0 pb-0">
                                                                <div class="card-cont">
                                                                    <h6 ref="cardContentLocation"><b>เส้นทางท่องวังพญานาควัดมณีวงศ์</b></h6>
                                                                    <p class="gray-dark">
                                                                        <small>จ.นครนายก ภาคตะวันออก</small>
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div class="card-foot">
                                                                <span class="btn-txt-grey btn-icon d-inline-block">
                                                                    <span>
                                                                        <span class="info-btn">ดูรายละเอียด</span>
                                                                        <img class="svg"
                                                                            src="@/assets/list-detail/icon-arrow-right-grey.svg"
                                                                            alt="" />
                                                                    </span>
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </a>
                                                </div>
                                                <div class="col" >
                                                    <a href="/chacheangsao">
                                                        <div class="card card-vote">
                                                            <div class="card-img">
                                                                <img src="@/assets/img/_77-attractions/eastern/chachoengsao/chachoengsao-thumb.jpg"
                                                                    alt="" class="fw" />
                                                            </div>
                                                            <div class="card-body px-0 pb-0">
                                                                <div class="card-cont">
                                                                    <h6 ref="cardContentLocation"><b>เก็บแสงสุดท้ายที่ปลายสะพานแก้ว…จุดชมพระอาทิตย์ตกเมืองแปดริ้ว</b></h6>
                                                                    <p class="gray-dark">
                                                                        <small>จ.ฉะเชิงเทรา ภาคตะวันออก</small>
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div class="card-foot">
                                                                <span class="btn-txt-grey btn-icon d-inline-block">
                                                                    <span>
                                                                        <span class="info-btn">ดูรายละเอียด</span>
                                                                        <img class="svg"
                                                                            src="@/assets/list-detail/icon-arrow-right-grey.svg"
                                                                            alt="" />
                                                                    </span>
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </a>
                                                </div>
                                                
                                                <div class="col" >
                                                    <a href="/rayong">
                                                        <div class="card card-vote">
                                                            <div class="card-img">
                                                                <img src="@/assets/img/_77-attractions/eastern/rayong/rayong-thumb.jpg"
                                                                    alt="" class="fw" />
                                                            </div>
                                                            <div class="card-body px-0 pb-0">
                                                                <div class="card-cont">
                                                                    <h6 ref="cardContentLocation"><b>Unseen ถ้ำในถ้ำ…สำรวจความลึกลับแห่งหุบเขาพญานาค</b></h6>
                                                                    <p class="gray-dark">
                                                                        <small>จ.ระยอง ภาคตะวันออก</small>
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div class="card-foot">
                                                                <span class="btn-txt-grey btn-icon d-inline-block">
                                                                    <span>
                                                                        <span class="info-btn">ดูรายละเอียด</span>
                                                                        <img class="svg"
                                                                            src="@/assets/list-detail/icon-arrow-right-grey.svg"
                                                                            alt="" />
                                                                    </span>
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </a>
                                                </div>
                                                <div class="col" >
                                                    <a href="/sakaew">
                                                        <div class="card card-vote">
                                                            <div class="card-img">
                                                                <img src="@/assets/img/_77-attractions/eastern/sakeaw/sakaeo-thumb.jpg"
                                                                    alt="" class="fw" />
                                                            </div>
                                                            <div class="card-body px-0 pb-0">
                                                                <div class="card-cont">
                                                                    <h6 ref="cardContentLocation"><b>ผจญภัยเมืองบาดาล…พิสูจน์ตำนานพญานาคแห่งถ้ำน้ำเขาศิวะ</b></h6>
                                                                    <p class="gray-dark">
                                                                        <small>จ.สระแก้ว ภาคตะวันออก</small>
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div class="card-foot">
                                                                <span
                                                                    class="nx-bg-pd-primary judge-tag text-light">
                                                                    <img class="svg judge-icon"
                                                                        src="@/assets/list-detail/icon-Star.svg" alt="" />
                                                                    <span
                                                                        class="d-none d-xl-block judge-txt">คัดเลือกโดยผู้ทรงคุณวุฒิ</span>
                                                                    <span
                                                                        class="d-block d-xl-none judge-txt">ผู้ทรงคุณวุฒิ</span>
                                                                </span>
                                                                <span class="btn-txt-grey btn-icon d-inline-block">
                                                                    <span>
                                                                        <span class="info-btn">ดูรายละเอียด</span>
                                                                        <img class="svg"
                                                                            src="@/assets/list-detail/icon-arrow-right-grey.svg"
                                                                            alt="" />
                                                                    </span>
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </a>
                                                </div>
                                                <div class="col" >
                                                    <a href="/surat-thani">
                                                        <div class="card card-vote">
                                                            <div class="card-img">
                                                                <img src="@/assets/img/_77-attractions/south/surat-thani/surat-thani-thumb.jpg"
                                                                    alt="" class="fw" />
                                                            </div>
                                                            <div class="card-body px-0 pb-0">
                                                                <div class="card-cont">
                                                                    <h6 ref="cardContentLocation"><b>ท่องอุทยานธรรมลอยฟ้า…พลังศรัทธาแห่งเขานาในหลวง</b></h6>
                                                                    <p class="gray-dark">
                                                                        <small>จ.สุราษฎร์ธานี ภาคใต้</small>
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div class="card-foot">
                                                                
                                                                <span class="btn-txt-grey btn-icon d-inline-block">
                                                                    <span>
                                                                        <span class="info-btn">ดูรายละเอียด</span>
                                                                        <img class="svg"
                                                                            src="@/assets/list-detail/icon-arrow-right-grey.svg"
                                                                            alt="" />
                                                                    </span>
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </a>
                                                </div>
                                                <div class="col" >
                                                    <a href="/ranong">
                                                        <div class="card card-vote">
                                                            <div class="card-img">
                                                                <img src="@/assets/img/_77-attractions/south/ranong/ranong-thumb.jpg"
                                                                    alt="" class="fw" />
                                                            </div>
                                                            <div class="card-body px-0 pb-0">
                                                                <div class="card-cont">
                                                                    <h6 ref="cardContentLocation"><b>ย้อนเวลาหาความสงบสุข…เที่ยวเกาะหลงยุคแห่งอันดามัน</b></h6>
                                                                    <p class="gray-dark">
                                                                        <small>จ.ระนอง ภาคใต้</small>
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div class="card-foot">
                                                                <span class="btn-txt-grey btn-icon d-inline-block">
                                                                    <span>
                                                                        <span class="info-btn">ดูรายละเอียด</span>
                                                                        <img class="svg"
                                                                            src="@/assets/list-detail/icon-arrow-right-grey.svg"
                                                                            alt="" />
                                                                    </span>
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </a>
                                                </div>
                                                <div class="col" >
                                                    <a href="/phuket">
                                                        <div class="card card-vote">
                                                            <div class="card-img">
                                                                <img src="@/assets/img/_77-attractions/south/phuket/phuket-thumb.jpg"
                                                                    alt="" class="fw" />
                                                            </div>
                                                            <div class="card-body px-0 pb-0">
                                                                <div class="card-cont">
                                                                    <h6 ref="cardContentLocation"><b>พลังศรัทธาใต้มหาสมุทร…รอยพระพุทธบาทแห่งอันดามัน</b></h6>
                                                                    <p class="gray-dark">
                                                                        <small>จ.ภูเก็ต ภาคใต้</small>
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div class="card-foot">
                                                                <span class="btn-txt-grey btn-icon d-inline-block">
                                                                    <span>
                                                                        <span class="info-btn">ดูรายละเอียด</span>
                                                                        <img class="svg"
                                                                            src="@/assets/list-detail/icon-arrow-right-grey.svg"
                                                                            alt="" />
                                                                    </span>
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </a>
                                                </div>
                                                
                                                <div class="col" >
                                                    <a href="/nakhon-si-thammarat">
                                                        <div class="card card-vote">
                                                            <div class="card-img">
                                                                <img src="@/assets/img/_77-attractions/south/nakhon-si-thammarat/nakhon-si-thammarat-thumb.jpg"
                                                                    alt="" class="fw" />
                                                            </div>
                                                            <div class="card-body px-0 pb-0">
                                                                <div class="card-cont">
                                                                    <h6 ref="cardContentLocation"><b>มหัศจรรย์แห่งชั้นหิน…งานศิลป์ถิ่นเมืองคอน</b></h6>
                                                                    <p class="gray-dark">
                                                                        <small>จ.นครศรีธรรมราช ภาคใต้</small>
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div class="card-foot">
                                                                <span class="btn-txt-grey btn-icon d-inline-block">
                                                                    <span>
                                                                        <span class="info-btn">ดูรายละเอียด</span>
                                                                        <img class="svg"
                                                                            src="@/assets/list-detail/icon-arrow-right-grey.svg"
                                                                            alt="" />
                                                                    </span>
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </a>
                                                </div>
                                                <div class="col" >
                                                    <a href="/satun">
                                                        <div class="card card-vote">
                                                            <div class="card-img">
                                                                <img src="@/assets/img/_77-attractions/south/satun/satun-thumb.jpg"
                                                                    alt="" class="fw" />
                                                            </div>
                                                            <div class="card-body px-0 pb-0">
                                                                <div class="card-cont">
                                                                    <h6 ref="cardContentLocation"><b>ผจญภัยในตะรุเตา…ตามหาเงาราชาโจรสลัดเมืองไทย</b></h6>
                                                                    <p class="gray-dark">
                                                                        <small>จ.สตูล ภาคใต้</small>
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div class="card-foot">
                                                                <span
                                                                    class="nx-bg-pd-primary judge-tag text-light">
                                                                    <img class="svg judge-icon"
                                                                        src="@/assets/list-detail/icon-Star.svg" alt="" />
                                                                    <span
                                                                        class="d-none d-xl-block judge-txt">คัดเลือกโดยผู้ทรงคุณวุฒิ</span>
                                                                    <span
                                                                        class="d-block d-xl-none judge-txt">ผู้ทรงคุณวุฒิ</span>
                                                                </span>
                                                                <span class="btn-txt-grey btn-icon d-inline-block">
                                                                    <span>
                                                                        <span class="info-btn">ดูรายละเอียด</span>
                                                                        <img class="svg"
                                                                            src="@/assets/list-detail/icon-arrow-right-grey.svg"
                                                                            alt="" />
                                                                    </span>
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </a>
                                                </div>
                                                
                                        </div>
                                    </div>

                                    <div class="location-list" :class="[activeTab === 'north' ? 'active' : '']"
                                        ref="tabContent">
                                        <div
                                            class="row g-custom g-3 row-cols-2 row-cols-md-3 row-cols-lg-4 row-cols-xl-4 row-cols-xxl-5 g-4 g-xl-5">
                                            <div class="col" >
                                                    <a href="/phetchabun">
                                                        <div class="card card-vote">
                                                            <div class="card-img">
                                                                <img src="@/assets/img/_77-attractions/north/phetchabun/phetchabun-thumb.jpg"
                                                                    alt="" class="fw" />
                                                            </div>
                                                            <div class="card-body px-0 pb-0">
                                                                <div class="card-cont">
                                                                    <h6 ref="cardContentLocation"><b>มหัศจรรย์น้ำตกหมอกเมืองไทย</b></h6>
                                                                    <p class="gray-dark">
                                                                        <small>จ.เพชรบูรณ์ ภาคเหนือ</small>
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div class="card-foot">
                                                                <span class="btn-txt-grey btn-icon d-inline-block">
                                                                    <span>
                                                                        <span class="info-btn">ดูรายละเอียด</span>
                                                                        <img class="svg"
                                                                            src="@/assets/list-detail/icon-arrow-right-grey.svg"
                                                                            alt="" />
                                                                    </span>
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </a>
                                                </div>
                                                <div class="col" >
                                                    <a href="/nakhon-sawan">
                                                        <div class="card card-vote">
                                                            <div class="card-img">
                                                                <img src="@/assets/img/_77-attractions/north/nakhon-sawan/nakhon-sawan-thumb.jpg"
                                                                    alt="" class="fw" />
                                                            </div>
                                                            <div class="card-body px-0 pb-0">
                                                                <div class="card-cont">
                                                                    <h6 ref="cardContentLocation"><b>ความศิวิไลซ์…แห่งปากน้ำโพ</b></h6>
                                                                    <p class="gray-dark">
                                                                        <small>จ.นครสวรรค์ ภาคเหนือ</small>
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div class="card-foot">
                                                                <span class="btn-txt-grey btn-icon d-inline-block">
                                                                    <span>
                                                                        <span class="info-btn">ดูรายละเอียด</span>
                                                                        <img class="svg"
                                                                            src="@/assets/list-detail/icon-arrow-right-grey.svg"
                                                                            alt="" />
                                                                    </span>
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </a>
                                                </div>
                                                <div class="col" >
                                                    <a href="/lampang">
                                                        <div class="card card-vote">
                                                            <div class="card-img">
                                                                <img src="@/assets/img/_77-attractions/north/lampang/lampang-thumb.jpg"
                                                                    alt="" class="fw" />
                                                            </div>
                                                            <div class="card-body px-0 pb-0">
                                                                <div class="card-cont">
                                                                    <h6 ref="cardContentLocation"><b>นมัสการพระใหญ่…ลมหายใจแห่งไดบุตสึ</b></h6>
                                                                    <p class="gray-dark">
                                                                        <small>จ.ลำปาง ภาคเหนือ</small>
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div class="card-foot">
                                                                <span class="btn-txt-grey btn-icon d-inline-block">
                                                                    <span>
                                                                        <span class="info-btn">ดูรายละเอียด</span>
                                                                        <img class="svg"
                                                                            src="@/assets/list-detail/icon-arrow-right-grey.svg"
                                                                            alt="" />
                                                                    </span>
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </a>
                                                </div>
                                                <div class="col" >
                                                    <a href="/lamphun">
                                                        <div class="card card-vote">
                                                            <div class="card-img">
                                                                <img src="@/assets/img/_77-attractions/north/lamphun/lamphun-thumb.jpg"
                                                                    alt="" class="fw" />
                                                            </div>
                                                            <div class="card-body px-0 pb-0">
                                                                <div class="card-cont">
                                                                    <h6 ref="cardContentLocation"><b>ตระการตาแห่งสีสัน…มหัศจรรย์ทะเลโคม</b></h6>
                                                                    <p class="gray-dark">
                                                                        <small>จ.ลำพูน ภาคเหนือ</small>
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div class="card-foot">
                                                                <span class="btn-txt-grey btn-icon d-inline-block">
                                                                    <span>
                                                                        <span class="info-btn">ดูรายละเอียด</span>
                                                                        <img class="svg"
                                                                            src="@/assets/list-detail/icon-arrow-right-grey.svg"
                                                                            alt="" />
                                                                    </span>
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </a>
                                                </div>
                                                <div class="col" >
                                                    <a href="/nan">
                                                        <div class="card card-vote">
                                                            <div class="card-img">
                                                                <img src="@/assets/img/_77-attractions/north/nan/nan-thumb.jpg"
                                                                    alt="" class="fw" />
                                                            </div>
                                                            <div class="card-body px-0 pb-0">
                                                                <div class="card-cont">
                                                                    <h6 ref="cardContentLocation"><b>ธรรม...ในถ้ำ วัดถ้ำเชตวัน</b></h6>
                                                                    <p class="gray-dark">
                                                                        <small>จ.น่าน ภาคเหนือ</small>
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div class="card-foot">
                                                                <span
                                                                    class="nx-bg-pd-primary judge-tag text-light">
                                                                    <img class="svg judge-icon"
                                                                        src="@/assets/list-detail/icon-Star.svg" alt="" />
                                                                    <span
                                                                        class="d-none d-xl-block judge-txt">คัดเลือกโดยผู้ทรงคุณวุฒิ</span>
                                                                    <span
                                                                        class="d-block d-xl-none judge-txt">ผู้ทรงคุณวุฒิ</span>
                                                                </span>
                                                                <span class="btn-txt-grey btn-icon d-inline-block">
                                                                    <span>
                                                                        <span class="info-btn">ดูรายละเอียด</span>
                                                                        <img class="svg"
                                                                            src="@/assets/list-detail/icon-arrow-right-grey.svg"
                                                                            alt="" />
                                                                    </span>
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </a>
                                                </div>
                                        </div>
                                    </div>

                                    <div class="location-list" :class="[activeTab === 'central' ? 'active' : '']"
                                        ref="tabContent">
                                        <div
                                            class="row g-custom g-3 row-cols-2 row-cols-md-3 row-cols-lg-4 row-cols-xl-4 row-cols-xxl-5 g-4 g-xl-5">
                                            <div class="col" >
                                                    <a href="/saraburi">
                                                        <div class="card card-vote">
                                                            <div class="card-img">
                                                                <img src="@/assets/img/_77-attractions/central/saraburi/saraburi-thumb.jpg"
                                                                    alt="" class="fw" />
                                                            </div>
                                                            <div class="card-body px-0 pb-0">
                                                                <div class="card-cont">
                                                                    <h6 ref="cardContentLocation"><b>ธรรมะแกลลอรี่…คอมมูนิตี้กลางหุบเขา</b></h6>
                                                                    <p class="gray-dark">
                                                                        <small>ภาคกลาง จ.สระบุรี</small>
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div class="card-foot">
                                                                
                                                                <span class="btn-txt-grey btn-icon d-inline-block">
                                                                    <span>
                                                                        <span class="info-btn">ดูรายละเอียด</span>
                                                                        <img class="svg"
                                                                            src="@/assets/list-detail/icon-arrow-right-grey.svg"
                                                                            alt="" />
                                                                    </span>
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </a>
                                                </div>
                                                <div class="col" >
                                                    <a href="/petchaburi">
                                                        <div class="card card-vote">
                                                            <div class="card-img">
                                                                <img src="@/assets/img/_77-attractions/central/phetchaburi/phetchaburi-thumb.jpg"
                                                                    alt="" class="fw" />
                                                            </div>
                                                            <div class="card-body px-0 pb-0">
                                                                <div class="card-cont">
                                                                    <h6 ref="cardContentLocation"><b>ผจญภัยในถ้ำโบ้…สำรวจถ้ำแห่งเขาอีบิด</b></h6>
                                                                    <p class="gray-dark">
                                                                        <small>ภาคกลาง จ.เพชรบุรี</small>
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div class="card-foot">
                                                                <span class="btn-txt-grey btn-icon d-inline-block">
                                                                    <span>
                                                                        <span class="info-btn">ดูรายละเอียด</span>
                                                                        <img class="svg"
                                                                            src="@/assets/list-detail/icon-arrow-right-grey.svg"
                                                                            alt="" />
                                                                    </span>
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </a>
                                                </div>
                                                <div class="col" >
                                                    <a href="/kanchanaburi">
                                                        <div class="card card-vote">
                                                            <div class="card-img">
                                                                <img src="@/assets/img/_77-attractions/central/kanchanaburi/kanchanaburi-thumb.jpg"
                                                                    alt="" class="fw" />
                                                            </div>
                                                            <div class="card-body px-0 pb-0">
                                                                <div class="card-cont">
                                                                    <h6 ref="cardContentLocation"><b>ฝ่าอุโมงค์สามมิติ…พิชิตป่าล้อมเหมือง</b></h6>
                                                                    <p class="gray-dark">
                                                                        <small>ภาคกลาง จ.กาญจนบุรี</small>
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div class="card-foot">
                                                                <span class="btn-txt-grey btn-icon d-inline-block">
                                                                    <span>
                                                                        <span class="info-btn">ดูรายละเอียด</span>
                                                                        <img class="svg"
                                                                            src="@/assets/list-detail/icon-arrow-right-grey.svg"
                                                                            alt="" />
                                                                    </span>
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </a>
                                                </div>
                                                <div class="col" >
                                                    <a href="/ratchaburi">
                                                        <div class="card card-vote">
                                                            <div class="card-img">
                                                                <img src="@/assets/img/_77-attractions/central/ratchaburi/ratchaburi-thumb.jpg"
                                                                    alt="" class="fw" />
                                                            </div>
                                                            <div class="card-body px-0 pb-0">
                                                                <div class="card-cont">
                                                                    <h6 ref="cardContentLocation"><b>อันซีนภูผาแรด…มุมลับสุดอาร์ตแห่งราชบุรี</b></h6>
                                                                    <p class="gray-dark">
                                                                        <small>จ.ราชบุรี ภาคกลาง</small>
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div class="card-foot">
                                                                <span class="btn-txt-grey btn-icon d-inline-block">
                                                                    <span>
                                                                        <span class="info-btn">ดูรายละเอียด</span>
                                                                        <img class="svg"
                                                                            src="@/assets/list-detail/icon-arrow-right-grey.svg"
                                                                            alt="" />
                                                                    </span>
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </a>
                                                </div>
                                                <div class="col" >
                                                    <a href="/prachuap-khiri-khan">
                                                        <div class="card card-vote">
                                                            <div class="card-img">
                                                                <img src="@/assets/img/_77-attractions/central/prachuap-khiri-khan/prachuap-khiri-khan-thumb.jpg"
                                                                    alt="" class="fw" />
                                                            </div>
                                                            <div class="card-body px-0 pb-0">
                                                                <div class="card-cont">
                                                                    <h6 ref="cardContentLocation"><b>มหาเจดีย์แห่งรัชสมัย…ความภาคภูมิใจแห่งบางสะพาน</b></h6>
                                                                    <p class="gray-dark">
                                                                        <small>จ.ประจวบคีรีขันธ์ ภาคกลาง</small>
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div class="card-foot">
                                                                <span
                                                                    class="nx-bg-pd-primary judge-tag text-light">
                                                                    <img class="svg judge-icon"
                                                                        src="@/assets/list-detail/icon-Star.svg" alt="" />
                                                                    <span
                                                                        class="d-none d-xl-block judge-txt">คัดเลือกโดยผู้ทรงคุณวุฒิ</span>
                                                                    <span
                                                                        class="d-block d-xl-none judge-txt">ผู้ทรงคุณวุฒิ</span>
                                                                </span>
                                                                <span class="btn-txt-grey btn-icon d-inline-block">
                                                                    <span>
                                                                        <span class="info-btn">ดูรายละเอียด</span>
                                                                        <img class="svg"
                                                                            src="@/assets/list-detail/icon-arrow-right-grey.svg"
                                                                            alt="" />
                                                                    </span>
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </a>
                                                </div>
                                        </div>
                                    </div>

                                    <div class="location-list" :class="[activeTab === 'northeast' ? 'active' : '']"
                                        ref="tabContent">
                                        <div
                                            class="row g-custom g-3 row-cols-2 row-cols-md-3 row-cols-lg-4 row-cols-xl-4 row-cols-xxl-5 g-4 g-xl-5">
                                            <div class="col" >
                                                    <a href="/chaiyaphum">
                                                        <div class="card card-vote">
                                                            <div class="card-img">
                                                                <img src="@/assets/img/_77-attractions/northeast/chaiyaphum/chaiyaphum-thumb.jpg"
                                                                    alt="" class="fw" />
                                                            </div>
                                                            <div class="card-body px-0 pb-0">
                                                                <div class="card-cont">
                                                                    <h6 ref="cardContentLocation"><b>ท่องอาณาจักรสวนหินล้านปี มอหินขาว</b></h6>
                                                                    <p class="gray-dark">
                                                                        <small>จ.ชัยภูมิ ภาคอีสาน</small>
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div class="card-foot">
                                                                <span class="btn-txt-grey btn-icon d-inline-block">
                                                                    <span>
                                                                        <span class="info-btn">ดูรายละเอียด</span>
                                                                        <img class="svg"
                                                                            src="@/assets/list-detail/icon-arrow-right-grey.svg"
                                                                            alt="" />
                                                                    </span>
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </a>
                                                </div>
                                                <div class="col" >
                                                    <a href="/loei">
                                                        <div class="card card-vote">
                                                            <div class="card-img">
                                                                <img src="@/assets/img/_77-attractions/northeast/loei/loei-thumb.jpg"
                                                                    alt="" class="fw" />
                                                            </div>
                                                            <div class="card-body px-0 pb-0">
                                                                <div class="card-cont">
                                                                    <h6 ref="cardContentLocation"><b>พิสูจน์ความฟิต…พิชิตทะเลหมอก ณ วนอุทยานภูบ่อบิด</b></h6>
                                                                    <p class="gray-dark">
                                                                        <small>จ.เลย ภาคอีสาน</small>
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div class="card-foot">
                                                                <span class="btn-txt-grey btn-icon d-inline-block">
                                                                    <span>
                                                                        <span class="info-btn">ดูรายละเอียด</span>
                                                                        <img class="svg"
                                                                            src="@/assets/list-detail/icon-arrow-right-grey.svg"
                                                                            alt="" />
                                                                    </span>
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </a>
                                                </div>
                                                <div class="col" >
                                                    <a href="/sisaket">
                                                        <div class="card card-vote">
                                                            <div class="card-img">
                                                                <img src="@/assets/img/_77-attractions/northeast/sisaket/sisaket-thumb.jpg"
                                                                    alt="" class="fw" />
                                                            </div>
                                                            <div class="card-body px-0 pb-0">
                                                                <div class="card-cont">
                                                                    <h6 ref="cardContentLocation"><b>ชมวิวบนยอดผา ณ ผืนป่าบ้านพญากูปรี</b></h6>
                                                                    <p class="gray-dark">
                                                                        <small>จ.ศรีสะเกษ ภาคอีสาน</small>
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div class="card-foot">
                                                              
                                                                <span class="btn-txt-grey btn-icon d-inline-block">
                                                                    <span>
                                                                        <span class="info-btn">ดูรายละเอียด</span>
                                                                        <img class="svg"
                                                                            src="@/assets/list-detail/icon-arrow-right-grey.svg"
                                                                            alt="" />
                                                                    </span>
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </a>
                                                </div>
                                                <div class="col" >
                                                    <a href="/nakhon-ratchasima">
                                                        <div class="card card-vote">
                                                            <div class="card-img">
                                                                <img src="@/assets/img/_77-attractions/northeast/nakhon-ratchasima/nakhon-ratchasima-thumb.jpg"
                                                                    alt="" class="fw" />
                                                            </div>
                                                            <div class="card-body px-0 pb-0">
                                                                <div class="card-cont">
                                                                    <h6 ref="cardContentLocation"><b>สัมผัสเสน่ห์เหนือกาลเวลา ณ ชุมชนบ้านปรางค์นคร อาณาจักรย่าโม</b></h6>
                                                                    <p class="gray-dark">
                                                                        <small>จ.นครราชสีมา ภาคอีสาน</small>
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div class="card-foot">
                                                                <span class="btn-txt-grey btn-icon d-inline-block">
                                                                    <span>
                                                                        <span class="info-btn">ดูรายละเอียด</span>
                                                                        <img class="svg"
                                                                            src="@/assets/list-detail/icon-arrow-right-grey.svg"
                                                                            alt="" />
                                                                    </span>
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </a>
                                                </div>
                                                
                                                <div class="col" >
                                                    <a href="/maha-sarakham">
                                                        <div class="card card-vote">
                                                            <div class="card-img">
                                                                <img src="@/assets/img/_77-attractions/northeast/maha-sarakham/maha-sarakham-thumb.jpg"
                                                                    alt="" class="fw" />
                                                            </div>
                                                            <div class="card-body px-0 pb-0">
                                                                <div class="card-cont">
                                                                    <h6 ref="cardContentLocation"><b>มหาศรัทธา…มหาอุโบสถตะเคียนทอง</b></h6>
                                                                    <p class="gray-dark">
                                                                        <small>จ.มหาสารคาม ภาคอีสาน</small>
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div class="card-foot">
                                                                <span
                                                                    class="nx-bg-pd-primary judge-tag text-light">
                                                                    <img class="svg judge-icon"
                                                                        src="@/assets/list-detail/icon-Star.svg" alt="" />
                                                                    <span
                                                                        class="d-none d-xl-block judge-txt">คัดเลือกโดยผู้ทรงคุณวุฒิ</span>
                                                                    <span
                                                                        class="d-block d-xl-none judge-txt">ผู้ทรงคุณวุฒิ</span>
                                                                </span>
                                                                <span class="btn-txt-grey btn-icon d-inline-block">
                                                                    <span>
                                                                        <span class="info-btn">ดูรายละเอียด</span>
                                                                        <img class="svg"
                                                                            src="@/assets/list-detail/icon-arrow-right-grey.svg"
                                                                            alt="" />
                                                                    </span>
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </a>
                                                </div>
                                        </div>
                                    </div>

                                    <div class="location-list" :class="[activeTab === 'eastern' ? 'active' : '']"
                                        ref="tabContent">
                                        <div
                                            class="row g-custom g-3 row-cols-2 row-cols-md-3 row-cols-lg-4 row-cols-xl-4 row-cols-xxl-5 g-4 g-xl-5">
                                            <div class="col" >
                                                    <a href="/chonburi">
                                                        <div class="card card-vote">
                                                            <div class="card-img">
                                                                <img src="@/assets/img/_77-attractions/eastern/chonburi/chonburi-thumb.jpg"
                                                                    alt="" class="fw" />
                                                            </div>
                                                            <div class="card-body px-0 pb-0">
                                                                <div class="card-cont">
                                                                    <h6 ref="cardContentLocation"><b>อันซีนเกาะแห่งรัก(ษ์)...ที่สีชัง</b></h6>
                                                                    <p class="gray-dark">
                                                                        <small>จ.ชลบุรี ภาคตะวันออก</small>
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div class="card-foot">
                                                                <span class="btn-txt-grey btn-icon d-inline-block">
                                                                    <span>
                                                                        <span class="info-btn">ดูรายละเอียด</span>
                                                                        <img class="svg"
                                                                            src="@/assets/list-detail/icon-arrow-right-grey.svg"
                                                                            alt="" />
                                                                    </span>
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </a>
                                                </div>
                                                <div class="col" >
                                                    <a href="/nakhonnayok">
                                                        <div class="card card-vote">
                                                            <div class="card-img">
                                                                <img src="@/assets/img/_77-attractions/eastern/nakhonnayok/nakhonnayok-thumb.jpg"
                                                                    alt="" class="fw" />
                                                            </div>
                                                            <div class="card-body px-0 pb-0">
                                                                <div class="card-cont">
                                                                    <h6 ref="cardContentLocation"><b>เส้นทางท่องวังพญานาควัดมณีวงศ์</b></h6>
                                                                    <p class="gray-dark">
                                                                        <small>จ.นครนายก ภาคตะวันออก</small>
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div class="card-foot">
                                                                <span class="btn-txt-grey btn-icon d-inline-block">
                                                                    <span>
                                                                        <span class="info-btn">ดูรายละเอียด</span>
                                                                        <img class="svg"
                                                                            src="@/assets/list-detail/icon-arrow-right-grey.svg"
                                                                            alt="" />
                                                                    </span>
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </a>
                                                </div>
                                                <div class="col" >
                                                    <a href="/chacheangsao">
                                                        <div class="card card-vote">
                                                            <div class="card-img">
                                                                <img src="@/assets/img/_77-attractions/eastern/chachoengsao/chachoengsao-thumb.jpg"
                                                                    alt="" class="fw" />
                                                            </div>
                                                            <div class="card-body px-0 pb-0">
                                                                <div class="card-cont">
                                                                    <h6 ref="cardContentLocation"><b>เก็บแสงสุดท้ายที่ปลายสะพานแก้ว…จุดชมพระอาทิตย์ตกเมืองแปดริ้ว</b></h6>
                                                                    <p class="gray-dark">
                                                                        <small>จ.ฉะเชิงเทรา ภาคตะวันออก</small>
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div class="card-foot">
                                                                <span class="btn-txt-grey btn-icon d-inline-block">
                                                                    <span>
                                                                        <span class="info-btn">ดูรายละเอียด</span>
                                                                        <img class="svg"
                                                                            src="@/assets/list-detail/icon-arrow-right-grey.svg"
                                                                            alt="" />
                                                                    </span>
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </a>
                                                </div>
                                                
                                                <div class="col" >
                                                    <a href="/rayong">
                                                        <div class="card card-vote">
                                                            <div class="card-img">
                                                                <img src="@/assets/img/_77-attractions/eastern/rayong/rayong-thumb.jpg"
                                                                    alt="" class="fw" />
                                                            </div>
                                                            <div class="card-body px-0 pb-0">
                                                                <div class="card-cont">
                                                                    <h6 ref="cardContentLocation"><b>Unseen ถ้ำในถ้ำ…สำรวจความลึกลับแห่งหุบเขาพญานาค</b></h6>
                                                                    <p class="gray-dark">
                                                                        <small>จ.ระยอง ภาคตะวันออก</small>
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div class="card-foot">
                                                                <span class="btn-txt-grey btn-icon d-inline-block">
                                                                    <span>
                                                                        <span class="info-btn">ดูรายละเอียด</span>
                                                                        <img class="svg"
                                                                            src="@/assets/list-detail/icon-arrow-right-grey.svg"
                                                                            alt="" />
                                                                    </span>
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </a>
                                                </div>
                                                <div class="col" >
                                                    <a href="/sakaew">
                                                        <div class="card card-vote">
                                                            <div class="card-img">
                                                                <img src="@/assets/img/_77-attractions/eastern/sakeaw/sakaeo-thumb.jpg"
                                                                    alt="" class="fw" />
                                                            </div>
                                                            <div class="card-body px-0 pb-0">
                                                                <div class="card-cont">
                                                                    <h6 ref="cardContentLocation"><b>ผจญภัยเมืองบาดาล…พิสูจน์ตำนานพญานาคแห่งถ้ำน้ำเขาศิวะ</b></h6>
                                                                    <p class="gray-dark">
                                                                        <small>จ.สระแก้ว ภาคตะวันออก</small>
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div class="card-foot">
                                                                <span
                                                                    class="nx-bg-pd-primary judge-tag text-light">
                                                                    <img class="svg judge-icon"
                                                                        src="@/assets/list-detail/icon-Star.svg" alt="" />
                                                                    <span
                                                                        class="d-none d-xl-block judge-txt">คัดเลือกโดยผู้ทรงคุณวุฒิ</span>
                                                                    <span
                                                                        class="d-block d-xl-none judge-txt">ผู้ทรงคุณวุฒิ</span>
                                                                </span>
                                                                <span class="btn-txt-grey btn-icon d-inline-block">
                                                                    <span>
                                                                        <span class="info-btn">ดูรายละเอียด</span>
                                                                        <img class="svg"
                                                                            src="@/assets/list-detail/icon-arrow-right-grey.svg"
                                                                            alt="" />
                                                                    </span>
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </a>
                                                </div>
                                        </div>
                                    </div>

                                    <div class="location-list" :class="[activeTab === 'south' ? 'active' : '']"
                                        ref="tabContent">
                                        <div
                                            class="row g-custom g-3 row-cols-2 row-cols-md-3 row-cols-lg-4 row-cols-xl-4 row-cols-xxl-5 g-4 g-xl-5">
                                            <div class="col" >
                                                    <a href="/surat-thani">
                                                        <div class="card card-vote">
                                                            <div class="card-img">
                                                                <img src="@/assets/img/_77-attractions/south/surat-thani/surat-thani-thumb.jpg"
                                                                    alt="" class="fw" />
                                                            </div>
                                                            <div class="card-body px-0 pb-0">
                                                                <div class="card-cont">
                                                                    <h6 ref="cardContentLocation"><b>ท่องอุทยานธรรมลอยฟ้า…พลังศรัทธาแห่งเขานาในหลวง</b></h6>
                                                                    <p class="gray-dark">
                                                                        <small>จ.สุราษฎร์ธานี ภาคใต้</small>
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div class="card-foot">
                                                                
                                                                <span class="btn-txt-grey btn-icon d-inline-block">
                                                                    <span>
                                                                        <span class="info-btn">ดูรายละเอียด</span>
                                                                        <img class="svg"
                                                                            src="@/assets/list-detail/icon-arrow-right-grey.svg"
                                                                            alt="" />
                                                                    </span>
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </a>
                                                </div>
                                                <div class="col" >
                                                    <a href="/ranong">
                                                        <div class="card card-vote">
                                                            <div class="card-img">
                                                                <img src="@/assets/img/_77-attractions/south/ranong/ranong-thumb.jpg"
                                                                    alt="" class="fw" />
                                                            </div>
                                                            <div class="card-body px-0 pb-0">
                                                                <div class="card-cont">
                                                                    <h6 ref="cardContentLocation"><b>ย้อนเวลาหาความสงบสุข…เที่ยวเกาะหลงยุคแห่งอันดามัน</b></h6>
                                                                    <p class="gray-dark">
                                                                        <small>จ.ระนอง ภาคใต้</small>
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div class="card-foot">
                                                                <span class="btn-txt-grey btn-icon d-inline-block">
                                                                    <span>
                                                                        <span class="info-btn">ดูรายละเอียด</span>
                                                                        <img class="svg"
                                                                            src="@/assets/list-detail/icon-arrow-right-grey.svg"
                                                                            alt="" />
                                                                    </span>
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </a>
                                                </div>
                                                <div class="col" >
                                                    <a href="/phuket">
                                                        <div class="card card-vote">
                                                            <div class="card-img">
                                                                <img src="@/assets/img/_77-attractions/south/phuket/phuket-thumb.jpg"
                                                                    alt="" class="fw" />
                                                            </div>
                                                            <div class="card-body px-0 pb-0">
                                                                <div class="card-cont">
                                                                    <h6 ref="cardContentLocation"><b>พลังศรัทธาใต้มหาสมุทร…รอยพระพุทธบาทแห่งอันดามัน</b></h6>
                                                                    <p class="gray-dark">
                                                                        <small>จ.ภูเก็ต ภาคใต้</small>
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div class="card-foot">
                                                                <span class="btn-txt-grey btn-icon d-inline-block">
                                                                    <span>
                                                                        <span class="info-btn">ดูรายละเอียด</span>
                                                                        <img class="svg"
                                                                            src="@/assets/list-detail/icon-arrow-right-grey.svg"
                                                                            alt="" />
                                                                    </span>
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </a>
                                                </div>
                                                
                                                <div class="col" >
                                                    <a href="/nakhon-si-thammarat">
                                                        <div class="card card-vote">
                                                            <div class="card-img">
                                                                <img src="@/assets/img/_77-attractions/south/nakhon-si-thammarat/nakhon-si-thammarat-thumb.jpg"
                                                                    alt="" class="fw" />
                                                            </div>
                                                            <div class="card-body px-0 pb-0">
                                                                <div class="card-cont">
                                                                    <h6 ref="cardContentLocation"><b>มหัศจรรย์แห่งชั้นหิน…งานศิลป์ถิ่นเมืองคอน</b></h6>
                                                                    <p class="gray-dark">
                                                                        <small>จ.นครศรีธรรมราช ภาคใต้</small>
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div class="card-foot">
                                                                <span class="btn-txt-grey btn-icon d-inline-block">
                                                                    <span>
                                                                        <span class="info-btn">ดูรายละเอียด</span>
                                                                        <img class="svg"
                                                                            src="@/assets/list-detail/icon-arrow-right-grey.svg"
                                                                            alt="" />
                                                                    </span>
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </a>
                                                </div>
                                                <div class="col" >
                                                    <a href="/satun">
                                                        <div class="card card-vote">
                                                            <div class="card-img">
                                                                <img src="@/assets/img/_77-attractions/south/satun/satun-thumb.jpg"
                                                                    alt="" class="fw" />
                                                            </div>
                                                            <div class="card-body px-0 pb-0">
                                                                <div class="card-cont">
                                                                    <h6 ref="cardContentLocation"><b>ผจญภัยในตะรุเตา…ตามหาเงาราชาโจรสลัดเมืองไทย</b></h6>
                                                                    <p class="gray-dark">
                                                                        <small>จ.สตูล ภาคใต้</small>
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div class="card-foot">
                                                                <span
                                                                    class="nx-bg-pd-primary judge-tag text-light">
                                                                    <img class="svg judge-icon"
                                                                        src="@/assets/list-detail/icon-Star.svg" alt="" />
                                                                    <span
                                                                        class="d-none d-xl-block judge-txt">คัดเลือกโดยผู้ทรงคุณวุฒิ</span>
                                                                    <span
                                                                        class="d-block d-xl-none judge-txt">ผู้ทรงคุณวุฒิ</span>
                                                                </span>
                                                                <span class="btn-txt-grey btn-icon d-inline-block">
                                                                    <span>
                                                                        <span class="info-btn">ดูรายละเอียด</span>
                                                                        <img class="svg"
                                                                            src="@/assets/list-detail/icon-arrow-right-grey.svg"
                                                                            alt="" />
                                                                    </span>
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </a>
                                                </div>
                                        </div>
                                    </div>
                                    <!-- <template v-if="Object.keys(travelListZone.zones)">
                                <template v-for="(zones, index) in travelListZone.zones " :key="zones.id">
                                    <div class="location-list" :class="[activeTab === index ? 'active' : '']"
                                        ref="tabContent">
                                        <div
                                            class="row g-custom g-3 row-cols-2 row-cols-md-3 row-cols-lg-4 row-cols-xl-4 row-cols-xxl-5 g-4 g-xl-5">
                                            <template v-for="(zone, index) in zones " :key="zone.id">
                                                <div class="col" v-if="index <= 4" :key="index">
                                                    <a href="/prachuap">
                                                        <div class="card card-vote">
                                                            <div class="card-img">
                                                                <img :src="require(`@/assets/img/77-attractions/${zone.image_cover}`)"
                                                                    alt="" class="fw" />
                                                            </div>
                                                            <div class="card-body px-0 pb-0">
                                                                <div class="card-cont">
                                                                    <h6 ref="cardContentLocation"><b
                                                                            v-html="zone.location_name"></b></h6>
                                                                    <p class="gray-dark">
                                                                        <small>จ.{{ zone.province_th }} {{ zone.region_th
                                                                        }}</small>
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div class="card-foot">
                                                                <span v-if="index == 4"
                                                                    class="nx-bg-pd-primary judge-tag text-light">
                                                                    <img class="svg judge-icon"
                                                                        src="@/assets/list-detail/icon-Star.svg" alt="" />
                                                                    <span
                                                                        class="d-none d-xl-block judge-txt">คัดเลือกโดยผู้ทรงคุณวุฒิ</span>
                                                                    <span
                                                                        class="d-block d-xl-none judge-txt">ผู้ทรงคุณวุฒิ</span>
                                                                </span>
                                                                <span class="btn-txt-grey btn-icon d-inline-block">
                                                                    <span>
                                                                        <span class="info-btn">ดูรายละเอียด</span>
                                                                        <img class="svg"
                                                                            src="@/assets/list-detail/icon-arrow-right-grey.svg"
                                                                            alt="" />
                                                                    </span>
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </a>
                                                </div>
                                            </template>

                                        </div>
                                    </div>
                                </template>
                            </template> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="fw">
            <div class="st sec sec-newhone-location pd">
                <div class="bg-newhone-location"></div>
                <div class="container container-1360 mb-5">
                    <div class="position-relative">
                        <div class="ele ele-left-cloud-new d-md-block d-none ele-newhome-m">
                            <img src="@/assets/img/element/cloud-1.png" alt="" />
                        </div>
                        <div class="ele ele-right-cloud-new d-md-block d-none">
                            <img src="@/assets/img/element/cloud-1.png" alt="" />
                        </div>
                        <div class="st newhone-location-sec pd">
                            <div class="container container-1360">
                                <div class="position-relative">
                                    <div class="fw">
                                        <div class="box-title text-center mb-4">
                                            <h2 class="text-uppercase" style="font-weight: 600">
                                                <span>แหล่งท่องเที่ยว Unseen อื่นๆ</span>
                                            </h2>
                                        </div>
                                        <!-- location-slide-con -->
                                        <div class="location-swiper fw">
                                            <div class="box-location-slide">
                                                <div class="swiper location_slide">
                                                    <div class="swiper-wrapper">
                                                        <div class="swiper-slide" v-for="(zone,key) in unQualified" :key="key">
                                                            <div class="card card-vote ">
                                                                <div class="card-img pop-content">
                                                                    <img  
                                                                    @click="handlePopContentClick(zone.id,zone.location_name,zone.location,zone.province_th,zone.region_th,zone.detail,replaceExtension(zone.image_cover),zone.images,zone.vote,zone.region_en,zone.tel,zone.location_link)"
                                                                    :src="require(`@/assets/img/77-attractions/${replaceExtension(zone.image_cover)}`)" alt="" class="fw">
                                                                    
                                                                </div>
                                                                <div class="card-body px-0 pb-0">
                                                                    <div class="card-cont pop-content" @click="handlePopContentClick(zone.id,zone.location_name,zone.location,zone.province_th,zone.region_th,zone.detail,replaceExtension(zone.image_cover),zone.images,zone.vote,zone.region_en,zone.tel,zone.location_link)">
                                                                        <h6 ref="cardContentLocation"><b v-html="zone.location_name "></b></h6>
                                                                        <p class="gray-dark"><small>จ.{{ zone.province_th  }} {{ zone.region_th }}</small></p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="clearfix"></div>
                                        <div class="fw text-center newbottom-btn">
                                            <router-link to="/attractions"
                                                class="btn btn-ctr-primary btn-lg rounded-pill text-uppercase">ดูแหล่งท่องเที่ยว Unseen
                                                อื่นๆ</router-link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="newhome-foot-sec group-bg-foot fw">
            <div class="st sec-newhome-promo pd">
                <div class="bg-newhome-promo"></div>
                <div class="st sec-newhome-promotion pd">
                    <div class="container container-1360">
                        <div class="position-relative">
                            <div class="box-title text-center mb-4">
                                <h2 class="font-display">
                                    <span class="text-light text-uppercase">Unseen Deals</span>
                                </h2>
                                <h4><b>โปรโมชั่นสุดพิเศษ</b></h4>
                            </div>
                            <div class="promotion-swiper fw">
                                <div class="box-promotion-slide">
                                    <div class="swiper promotion_slide">
                                        <div class="swiper-wrapper">
                                            <div class="swiper-slide" v-for="item in promotions" :key="item.id">
                                                <div class="card-promotion" @click="
                                                    inItPromotion(
                                                        item.name,
                                                        item.description,
                                                        item.image,
                                                        item.link_out)">
                                                    <div class="card-promotion-image">
                                                       
                                                        <img :src="
                                                            require(`../../assets/img/promotion/${item.image}`)
                                                        " alt="" class="fw" />
                                                    </div>
                                                    <div class="card-promotion-text text-start">
                                                        <div class="card-pro-title" v-html="item.name"></div>
                                                        <a href="javascript:void(0)"
                                                            class="btn-txt-dark btn-icon d-inline-block">
                                                            <span><span class="">ดูรายละเอียด</span>
                                                                <img class="svg"
                                                                    src="@/assets/img/skin/icon-arrow-right-primary.svg"
                                                                    alt="" /></span>
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="swiper-pagination"></div>
                                </div>
                            </div>
                            <div class="clearfix"></div>
                            <div class="fw text-center mt-4">
                                <router-link to="/promotion"
                                    class="btn btn-ctr-primary btn-lg rounded-pill">ดูโปรโมชั่นเพิ่มเติม</router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <popupPromotion v-if="isPromotion" v-on:close-popup="(isPromotion = false), startAutoplay()"
        :promotionArray="promotionArray">
    </popupPromotion>

    <template v-if="show">
        <Transition name="fade " mode="out-in">
            <popupDetail @vote-clicked="handleVoteClicked"
                v-on:close-popup="show = false, startAutoplayLocation(), this.$root.metaDefault()"
                :popupContArray="popupContArray">

            </popupDetail>
        </Transition>
    </template>
    <loadPageComponent v-if="isloade" class="loadpage-com" :class="isloade == true ? isActive : isActive = '' "></loadPageComponent>

</template>
<script>
/* eslint-disable */
import { setFunction } from "@/global";
import { playVideo } from "@/global";
import { initSvg } from "@/global";
import popupPromotion from "@/components/popup/popupPromotion.vue";
import popupDetail from '@/components/popup/popupDetail.vue';
import loadPageComponent from "@/components/loadPageComponent.vue";
import { TweenMax, Power1, TimelineMax, gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
// STORE
import axios from "axios";
import { mapState, mapGetters } from 'vuex';
// SWIPER
import Swiper, {
    Autoplay,
    Navigation,
    Pagination,
    Controller,
    EffectFade,
} from "swiper";
Swiper.use([Autoplay, Navigation, Pagination, Controller, EffectFade]);
import "swiper/swiper-bundle.css";
import "swiper/css/pagination";
export default {
    name: "NewHomeView",
    components: { popupDetail, popupPromotion, loadPageComponent },
    data() {
        return {
            tabRegion: "all",
            activeTab: "all",
            isloade: true,
            isActive:'active',
            show: false,
            hidePreview: true,
            isPromotion: false,
            promotions: [],
            promotionArray: [],
            cardContent: '',
            cardImageArray: [],
            images: [
                'central/prachuap-khiri-khan/prachuap-khiri-khan-1.jpg',
                'central/prachuap-khiri-khan/prachuap-khiri-khan-1.jpg',
                'central/prachuap-khiri-khan/prachuap-khiri-khan-1.jpg',
                'central/prachuap-khiri-khan/prachuap-khiri-khan-1.jpg',


            ],
            galleryTop: null,
            galleryThumbs: null,
            popupContArray: [],
            unQualified: [],
            locationSlideInit: null,
            promotionSlideInit: null,
            tabs: [
                { label: "ทั้งหมด", label_en: "all" },
                { label: "ภาคเหนือ", label_en: "north" },
                { label: "ภาคกลาง", label_en: "central" },
                { label: "ภาคอีสาน", label_en: "northeast" },
                { label: "ภาคตะวันออก", label_en: "eastern" },
                { label: "ภาคใต้", label_en: "south" },
            ],
            tabCange: false,
            scrollTrigger: null,

        };
    },
    computed: {
        ...mapState(['travelListZone']),
        ...mapGetters(['loading']),
    },
    mounted() {

        document.title = 'Unseen New Chapters ปักหมุดใหม่ เปิดไทยมุมต่าง';
        document
            .querySelector('meta[name="description"]')
            .setAttribute("content", '25 แหล่งท่องเที่ยว UNSEEN มุมใหม่ของเมืองไทย');


        this.getLocation();
        this.getPromotions();
        this.getUnQualified();
        this.autoTab();
        console.log(this.travelListZone.zones);
        playVideo();
        var loadPage = ''
        setTimeout(() => {
            loadPage = 'true'
        }, 2000);
        var isloadeLoop =  setInterval(() => {
            if(loadPage != ''){
            if (document.querySelectorAll('.loadpage-com').length !== 0) {
                document.querySelector('.loadpage-com').classList.remove('active')
            }
                setTimeout(() => {
                    this.isloade = false;
                    clearInterval(isloadeLoop);
                }, 200);
        }else{
            this.isloade = true;
        }
            
        }, 1000);

        TweenMax.from('.bg-banner-kv', 1, { opacity: 0, }, .4);
        TweenMax.from('.ele-banner-kv-ink', 1, { opacity: 0, y: 200 }, .3);
        TweenMax.from('.newhome-logo', 1, { opacity: 0, x: -230, }, 1.6);
        TweenMax.from('.sec-newhome-location h2', 1, { opacity: 0, y: 50 }, 2);
        TweenMax.from('.sec-newhome-tab', 1, { opacity: 0, y: 50 }, 2.3);
        TweenMax.from('.newhome-video-banner', 1, { opacity: 0, x: 230 }, 1);

        TweenMax.from('.newhome-sub-m', 1, { opacity: 0, y: 200, }, 1);
        TweenMax.from('.newhome-logo-m', 1, { opacity: 0, y: -200, }, 1.6);
        TweenMax.from('.ele-banner-kv-ink-m', 1, { opacity: 0, y: 230 }, 1.6);

        // TweenMax.from('.location-list',1, { opacity: 0, y:120,},.4);
        TweenMax.fromTo('.ele-main-kv-cloud', 2, { y: 3 }, { y: 0, ease: Power1.easeInOut, repeat: -1, yoyo: true, delay: 1 });
        TweenMax.fromTo('.ele-left-cloud-new', 3, { x: 0 }, { x: -20, ease: Power1.easeInOut, repeat: -1, yoyo: true, delay: 0.8 });
        TweenMax.fromTo('.ele-right-cloud-new', 3, { x: 0 }, { x: -30, ease: Power1.easeInOut, repeat: -1, yoyo: true, delay: 0.8 });
    },
    methods: {
        replaceExtension(imageUrl) {
            return imageUrl.replace(/\.jpg$/, '.webp');
        },
        async getLocation() {
            try {
                this.$store.dispatch('fetchZones')
                this.$route.query.data;
                setTimeout(() => {
                    this.ScrollAnimate();
                }, 1000);
            } catch (error) {
                console.log(error);
            }
        },

        ScrollAnimate(tabCange) {
            gsap.registerPlugin(ScrollTrigger);
            const createScrollTrigger = (trigger, animation) => {
            ScrollTrigger.create({
                trigger,
                animation,
                onEnter: () => {
                    // gsap.from('.location-list', 1, { duration: 1, ease: 'power3.in-out', y: 100, alpha: 0 });
                    animation.play()
                },
            });
        }
        const locationUnseen = TweenMax.from('.location-list', 1, { duration: 1, ease: 'power3.in-out', y: 100, alpha: 0 });
        createScrollTrigger('.sec-locationlist', locationUnseen);

      
        },
        tabAnimateList() {
            // gsap.registerPlugin(ScrollTrigger);
            // const localList = document.querySelectorAll('.location-list');
            // if (Array.from(localList).some(element => element.classList.contains('active'))) {
            //     localList.forEach((element) => {
            //     const createScrollTrigger = (trigger, animation) => {
            //         ScrollTrigger.create({
            //             trigger,
            //             start: 'top 100%',
            //             animation,
            //             onEnter: () => {
            //                 animation.play();
            //             },
            //         });
            //     };
            //         const locationUnseen = TweenMax.from(element.querySelectorAll('.card'), 1, { duration: 1, ease: 'power3.in-out', y: 100, alpha: 0 });
            //         createScrollTrigger('.newhome-tab-content', locationUnseen);
            //     });
            // }
        },

        activateTab(index) {
            this.activeTab = index;
            this.tabCange = true;
            const container = this.$refs.tabList;
            this.tabAnimateList();
            setTimeout(() => {
                const activeElement = container.querySelector(".active");
                const scrollLeft =
                    activeElement.offsetLeft +
                    activeElement.offsetWidth / 2 -
                    container.offsetWidth / 2;
                container.scrollTo({
                    left: scrollLeft,
                    behavior: "smooth",
                });
            }, 50);
            console.log(container);
        },
        async getPromotions() {
            this.isloade = true;
            try {
                const response = await axios.get(
                    `https://www.unseennewchapters.com/nx/API/get_promotions`
                );
                if (response.data.rs == true) {
                    this.promotions = response.data.data.slice(0, 10);
                    this.promotionSlide();
                    setTimeout(() => {
                        initSvg();
                    }, 500);
                }
            } catch (error) {
                this.isloade = true;
            }
        },

        async getUnQualified() {
            this.isloade = true;
            try {
                const response = await axios.get(
                    `https://www.unseennewchapters.com/nx/API/get_locations_52`
                );
                if (response.data.rs == true) {
                    this.unQualified = response.data.data
                    // this.promotions = response.data.data.slice(0, 0);
                    // this.promotionSlide();
                    this.locationSlide();
                    setTimeout(() => {
                        initSvg();
                    }, 500);
                }
            } catch (error) {
                this.isloade = true;
            }
        },

        handlePopContentClick(id, location_name, location, province_th, region_th, detail, image_cover, images, vote, region_en, tel, location_link) {
            this.stopAutoplayLocation();
            this.show = true;
            this.popupContArray = [{
                id: id,
                location_name: location_name,
                location: location,
                province_th: province_th,
                region_th: region_th,
                detail: detail,
                image_cover: image_cover,
                images: images,
                vote: vote,
                region_en: region_en,
                tel: tel,
                location_link: location_link
            }]
            // window.history.pushState(null, null, `?slug=${id}`);
        },

        autoTab() {
            const tabRegions = this.$route.query.data;
            if (tabRegions != undefined) {
                setTimeout(() => {
                    document.querySelector('.sec-location-tab').scrollIntoView({ behavior: 'smooth' ,block:'center'});
                }, 2300);
            }
            if (tabRegions === 'all') {
                this.tabRegion = 'all';
                this.activateTab(this.tabRegion);
            } else if (tabRegions === 'north') {
                this.tabRegion = 'north';
                this.activateTab(this.tabRegion);
            } else if (tabRegions === 'central') {
                this.tabRegion = 'central';
                this.activateTab(this.tabRegion);
            } else if (tabRegions === 'northeast') {
                this.tabRegion = 'northeast';
                this.activateTab(this.tabRegion);
            } else if (tabRegions === 'eastern') {
                this.tabRegion = 'eastern';
                this.activateTab(this.tabRegion);
            } else if (tabRegions === 'south') {
                this.tabRegion = 'south';
                this.activateTab(this.tabRegion);
            }
        },
        inItPromotion(name, description, image, link_out) {
            this.stopAutoplay();
            this.isPromotion = true;
            this.promotionArray = [
                {
                    name: name,
                    description: description,
                    image: image,
                    link_out: link_out,
                },
            ];
        },
        promotionSlide() {
            this.promotionSlideInit = new Swiper(
                ".box-promotion-slide .promotion_slide",
                {
                    spaceBetween: 10,
                    slidesPerView: 1.4,
                    pagination: {
                        el: ".box-promotion-slide .swiper-pagination",
                        type: "bullets",
                        clickable: true,
                    },
                    speed: 1000,
                    autoplay: {
                        delay: 1000,
                        disableOnInteraction: true,
                    },
                    breakpoints: {
                        1119: {
                            slidesPerView: 3.5,
                            simulateTouch: true,
                        },
                        767: {
                            slidesPerView: 2.5,
                            simulateTouch: true,
                        },
                    },
                }
            );
        },
        stopAutoplay() {
            this.promotionSlideInit.autoplay.stop();
        },
        startAutoplay() {
            this.promotionSlideInit.autoplay.start();
        },
        locationSlide() {
            this.locationSlideInit = new Swiper(
                ".box-location-slide .location_slide",
                {
                    spaceBetween: 12,
                    slidesPerView: 2,
                    pagination: {
                        el: ".box-location-slide .swiper-pagination",
                        type: "bullets",
                        clickable: true,
                    },
                    speed: 1000,
                    autoplay: {
                        delay: 1000,
                        disableOnInteraction: true,
                    },
                    breakpoints: {
                        1119: {
                            spaceBetween: 13,
                            slidesPerView: 4,
                            simulateTouch: true,
                        },
                        1359: {
                            spaceBetween: 13,
                            slidesPerView: 4.9,
                        },
                        767: {
                            spaceBetween: 13,
                            slidesPerView: 3,
                        },
                    },
                }
            );
        },
        stopAutoplayLocation() {
            this.locationSlideInit.autoplay.stop();
        },
        startAutoplayLocation() {
            this.locationSlideInit.autoplay.start();
        },
    },

    beforeRouteEnter(to, from, next) {
        next(vm => {
            if (to.path === '/') {
                vm.$router.replace({ ...to, query: {} });
                setTimeout(() => {
                }, 1300);
            }
        });
    },
};
</script>
<style scoped>
.location-swiper .swiper-slide{height: auto !important;}

.location-list .card-cont {
    width: 100%;
}

.sec-newhome-main.pd {
    padding-top: 60px;
}

.sec-newhome-main {
    overflow: hidden;
    position: relative;
}

.sec-newhome-main .ele-main-kv-cloud {
    bottom: -56px;

}

.box-location-slide .swiper {
    overflow: visible;
}

.sec-newhome-main.bg-banner-kv {
    background: url(@/assets/list-detail/newhome/newhome-banner.jpg) center top no-repeat;
    background-size: cover;
}

.sec-newhome-main .banner-cont {
    align-items: normal;
    padding-bottom: 5em;
    justify-content: space-between;
}

.newhome-logo .logo-kv {
    height: 360px;
    margin-bottom: 2em;

}

.ele-left-cloud-new {
    top: 0;
    left: 0;
    margin-left: -25%;
    width: 49%;
}

.ele-right-cloud-new {
    top: 0;
    right: 0;
    margin-right: -40%;
    width: 55%;
}

.location-slide-con .card-cont {
    width: 100%;
    margin-right: 0;
}

.newbottom-btn {
    margin-top: 48px;
}

.sec-newhome-location {
    font-size: 1.4em;
    position: relative;
    border-radius: 20px;
    padding: 1em 2em 4em 2em;
}

.judge-tag {
    display: flex;
    padding: 2px 8px;
    border-radius: 5px;
    align-items: center;
}

.judge-txt {
    font-size: 10px;
    margin-left: 2px;
}

.judge-icon {
    width: 10px;
}

.card-foot .btn-icon>span img,
.btn-icon>span svg {
    height: 12px;
}

.sec-location-tab {
    /* margin-top: 10px; */
    padding-bottom: 50px;
}

.newhome-foot-sec.group-bg-foot {
    background: url(@/assets/list-detail/newhome/newhome-bg-bottom.jpg) center bottom no-repeat;
    background-size: 100%;
}

/* .sec-newhome-promotion {
    padding-bottom: 10em;
} */

.sec-newhone-location {
    position: relative;
}

.newhome-video-banner {
    position: relative;
}

.sec-newhome-promo {
    position: relative;
    padding-bottom: 150px;
}

/* .card-foot .btn-txt-grey svg path {
    fill: #a6a6a6 !important;
} */

.card-foot {
    display: flex;
    align-items: center;
    margin-top: 6px;
}

.location-list.active {
    display: block;
}

.location-list {
    display: none;
}

.location-list .card-vote .btn-txt-grey {
    color: #a6a6a6;
    font-weight: 300;
    font-size: 0.7em;
    margin-left: auto;
    text-decoration: underline;
}

.bg-newhome-promo {
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    position: absolute;
    pointer-events: none;
    background: rgba(197, 22, 140, 0);
    background: linear-gradient(0deg, rgba(197, 22, 140, 0) 55%, #ED3C95 120%);
}

.bg-newhone-location {
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    position: absolute;
    pointer-events: none;
    background: rgb(255, 244, 250);
    background: linear-gradient(360deg,
            rgba(255, 244, 250, 1) 0%,
            rgba(255, 194, 227, 1) 100%);
}

.newhome-video-banner .box-video {
    padding: 10px;
    margin-top: 20px;
    border-radius: 15px;
    background-color: #fff;
}

.newhome-video-banner .video-put {
    border-radius: 15px;
}

.newhome-logo h4 {
    font-size: 2em;
}

.newhome-logo {
    position: relative;
}

.newhome-video-banner .video-space,
.video-space img {
    border-radius: 15px;
}

.ele-banner-kv-ink {
    top: -50px;
    left: 19%;
    position: absolute;
    width: 57%;
    /* transform: translate(-42%, 0); */
}

.sec-newhome-tab {
    padding: 10px 20px;
    z-index: 3;
}

.sec-newhome-tab li.tab-list.active {
    padding: 10px 30px;
    border-radius: 50px;
    background-color: #fff;
}

.sec-newhome-tab.sec-tab {
    min-height: auto;
    border-radius: 50px;
    box-shadow: 0 15px 20px rgba(158, 35, 86, 0.6);
}

.sec-newhome-tab .tab-list {
    padding: 0 30px;
    min-height: auto;
    margin-right: 30px;
}

.sec-newhome-tab .tab-list a {
    font-size: 1em;
}

.sec-location-tab .tab-list.active:before {
    content: none;
}

.sec-newhome-tab.sec-tab ul {
    justify-content: center;
}

.swiper-container {
    width: 100%;
    height: 100%;
}

.swiper-slide img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

/* .newhome-logo .btn {
    font-size: 1.3em;
} */

@media(max-width: 1439px) {
    .ele-banner-kv-ink {
        width: 57%;
        top: -50px;
        left: 19%;
    }

    /* .newhome-logo {
        margin-left: 2em;
    } */
    .ele-left-cloud-new {
        margin-left: -20%;
    }

    .ele-right-cloud-new {
        margin-right: -30%;
    }
}

@media (max-width: 1359.98px) {
    .newhome-logo .logo-kv {
        height: 260px;
        margin-bottom: 1em;
    }

    .newhome-video-banner .video-put {
        border-radius: 15px;
        overflow: hidden;
    }

    .newhome-video-banner {
        width: 50%;
    }

    .ele-banner-kv-ink {
        top: -40px;
        width: 53%;
        left: 20%;
    }

    .sec-newhome-tab .tab-list {
        padding: 0 25px;
        margin-right: 0px;
    }
}

@media (max-width: 1199.98px) {

    .sec-location-tab {
        margin-top: 5px;
    }

    /* .newhome-logo .btn {
        font-size: 1em;
    } */

    .newhome-video-banner .videoplay-icon img {
        width: 20vw;
    }

    .sec-newhome-tab .tab-list {
        padding: 0 30px;
        margin-right: 0px;
    }

    /* .sec-newhome-tab .tab-list.active:before {
        height: calc(100% + 10px);
    } */

    .sec-newhome-main .ele-main-kv-cloud {
        bottom: -50px;
    }

    .newhome-logo .logo-kv {
        height: 180px;
        margin-bottom: .5em;
    }

    .ele-banner-kv-ink {
        top: -40px;
        left: 21%;
    }

    .newhome-logo {
        margin-left: 0em;
    }

    .newhome-logo h4 {
        font-size: 1.6em;
    }

    /* .sec-newhome-location {
        padding: 1.5em 2em 6em 2em;
        font-size: .8em;
    } */

    .sec-newhome-tab .tab-list {
        padding: 0 25px;
        margin-right: 0px;
    }

    .sec-newhome-tab.sec-tab {
        box-shadow: 0 5px 10px rgba(158, 35, 86, 0.6);
    }

    /* .sec-newhome-main .banner-cont {
        padding-bottom: 2em;
    } */

    .sec-newhome-location h2 {
        font-size: 1.7em;
    }

    .judge-tag {
        padding: 1px 8px;
    }

    .newhome-video-banner .box-video {
        padding: 8px;
    }
}

@media (max-width: 991.98px) {
    .sec-newhome-tab .tab-list {
        padding: 0 25px;
        margin-right: 20px;
    }

    .newhome-video-banner .videoplay-icon img {
        width: 10vw;
    }

    /* .sec-newhome-tab .tab-list a {
        font-size: 1.2em;
    } */
    .newhome-video-banner .box-video {
        padding: 5px;
        margin-top: 10px;
    }

    .ele-banner-kv-ink {
        top: -30px;
        left: 21%;
    }

    .sec-newhome-main .ele-main-kv-cloud {
        width: 120%;
        bottom: -20px;

    }

    .sec-newhome-main .banner-cont {
        padding-bottom: 1em;
    }

    .newhome-logo h4 {
        font-size: 1.4em;
    }

    .newhome-logo {
        margin-left: 0em;
    }



    .sec-newhome-tab.sec-tab {
        overflow: hidden;
        padding: 10px 10px;
        box-shadow: 0 5px 10px rgba(158, 35, 86, 0.6);
    }

    .sec-newhome-tab.sec-tab ul::-webkit-scrollbar {
        display: none;
    }

    .sec-newhome-tab.sec-tab ul {
        margin-left: -20px;
        padding-left: 20px;
        overflow-x: scroll;
        scrollbar-width: none;
        justify-content: start;
        -ms-overflow-style: none;
        width: calc(100% + 40px);
    }

    .sec-newhome-tab li.tab-list {
        flex: 0 0 auto;
        scroll-snap-align: start;
    }

    /* .sec-newhome-tab .tab-list.active:before {
        height: 100%;
    } */

    .sec-newhome-location h2 {
        font-size: 1.4em;
    }

    .sec-newhome-location {
        font-size: 1.5em;
        padding: 1em 1em 2em 1em;
    }
}

@media (max-width: 767.98px) {
    .newhome-video-banner .videoplay-icon img {
        width: 20vw;
    }

    .newhome-video-banner .box-video {
        padding: 4px;
    }

    .sec-newhome-tab.sec-tab ul {
        padding-right: 20px;
    }

    /* .sec-newhome-location {
        width: 120%;
        margin-left: -2em;
    } */

    .card-foot .btn-icon span+svg,
    .btn-icon span+img {
        margin-left: 4px;
    }

    .card-foot .btn-icon>span img,
    .btn-icon>span svg {
        height: 10px;
    }

    /* 
    .judge-tag {
        padding: 1px 3px;
    } */

    .info-btn {
        font-size: 10px;
    }

    .sec-newhome-main.bg-banner-kv {
        background-image: url(@/assets/list-detail/newhome/newhome-banner-m.jpg);
        background-size: cover;
    }

    .sec-newhome-tab .tab-list {
        padding: 0 20px;
        margin-right: 0px;
    }

    .newhome-foot-sec.group-bg-foot {
        background: url(@/assets/list-detail/newhome/newhome-bg-bottom-m.jpg);
        background-size: cover;
    }

    .sec-newhome-main .banner-cont {
        justify-content: center;
    }

    .newhome-video-banner {
        width: 100%;
    }

    .banner-kv .box-title {
        margin-top: -80px;
    }

    .sec-newhome-main .ele-main-kv-cloud {
        width: 120%;
        display: block;
    }

    .ele-banner-kv-ink-m {
        margin-top: 2em;
        margin-left: -1em;
        position: relative;
    }

    .newhome-logo-m {
        top: -2em;
        right: 0em;
        text-align: end;
        position: absolute;
    }

    .newhome-logo-m .logo-kv {
        width: 80%;
    }

    .sec-newhome-main .banner-cont {
        margin-top: -5em;
        padding-bottom: 2em;
    }

    .newhome-sub-m h2 {
        font-size: 1.5em;
    }

    .newhome-sub-m {
        margin-top: 20px;
        font-size: 1.5em;
    }

    .sec-newhome.sec-banner-main {
        height: 260px;
    }

    .sec-newhome-location h2 {
        font-weight: 600;
    }

}

@media (max-width: 575.98px) {
    .newhome-video-banner {
        width: 90%;
    }

    .newhome-foot-sec.group-bg-foot {
        background: url(@/assets/list-detail/newhome/newhome-bg-bottom-m.jpg) center bottom no-repeat;
        background-size: 100%;
    }

    .sec-newhome-promotion {
        padding-bottom: 3em;
    }

    .sec-newhome-tab .tab-list {
        padding: 0 20px;
        margin-right: 0px;
    }

    /* .info-btn {
        font-size: 10px;
    } */
    .newhome-sub-m h2 {
        font-size: 1.3em;
    }

    .sec-newhome-main .ele-main-kv-cloud {
        bottom: 0;
        width: 150%;
    }

    .sec-newhome-tab .tab-list a {
        font-size: 1em;
    }

    .sec-locationlist.pd {
        padding-top: 20px;
    }

    .sec-newhome-location {
        margin: 0;
        width: 100%;
    }

    .sec-newhome-location h2 {
        font-size: 1.1em;
        line-height: 1.2;
    }

    .newhome-sub-m {
        font-size: 1.3em;
    }

    .newhome-sub-m h2 {
        line-height: 1.2;

    }

    .ele-banner-kv-ink-m {
        width: 90%;
        margin-left: 1em;
        margin-top: -1em;
        position: relative;
    }

    .ele-newhome-m.ele-left-cloud {
        transform: translateY(50%);
    }

    .newhome-logo-m {
        top: -1em;
        right: 0em;
        text-align: end;
        position: absolute;
    }

    .sec-newhome-location {
        padding-top: .5em;
        padding-bottom: 2em;
        background: rgb(215, 10, 139);
        background: linear-gradient(0deg, rgba(215, 10, 139, 1) 40%, rgba(251, 176, 21, 1) 140%);
    }

    .newhome-logo-m .logo-kv {
        width: 32vw;
        margin-right: 6vw;
    }

    .sec-newhome-main .banner-cont {
        margin-top: -3em;
        padding-bottom: 30px;
    }

    .newhome-sub-m {
        margin-top: 20px;
    }

    .sec-newhome.sec-banner-main {
        height: 260px;
    }

    .sec-newhome-main {
        padding-top: 30px;
    }


}

@media (max-width: 414.99px) {
    .sec-newhome-main .banner-cont {
        margin-top: -3.2em;
    }

    .info-btn {
        font-size: 8px;
    }

    .card-foot .btn-icon span+svg,
    .btn-icon span+img {
        margin-left: 0px;
    }

    .card-foot .btn-icon>span img,
    .btn-icon>span svg {
        height: 8px;
    }

    .judge-txt {
        font-size: 8px;
    }

    .judge-tag {
        padding: 1px 4px;
        border-radius: 3px;
    }

}
</style>
